<template>
  <div id="salesmanList" >
    <!-- 查询选项 -->
    <Form class="salesmanForm" :label-width="100">
      <FormItem class="form_item" :label="$t('jobValue1')" >
        <Input clearable v-model="jobValue" :placeholder="$t('enter')"/>
      </FormItem>
      <FormItem class="form_item" :label="$t('jobDesc1')">
        <Input clearable v-model="jobDesc" :placeholder="$t('enter')"/>
      </FormItem>
      <div class="buttonDiv">
        <el-button type="primary" size="mini" @click="searchJobInfo">{{$t('search')}}</el-button>
        <el-button type="primary" size="mini" @click="addModel">{{$t('add')}}</el-button>
      </div>
    </Form>

    <div class="contentTableDiv">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
        <el-table-column prop="jobValue" :label="$t('jobValue')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="jobDesc" :label="$t('jobDesc')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="isRun" :label="$t('isvalid')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="cycelTime" :label="$t('cycelTime')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="jobTime" :label="$t('jobTime')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="runtime" :label="$t('runtime')" align="center" width="160"></el-table-column>
        <el-table-column prop="nextRuntime" :label="$t('nextRuntime')" align="center" width="160"></el-table-column>
        <el-table-column :label="$t('operate')" align="center" fixed="right"  width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button>
            <el-button size="mini" type="success" @click="handleRun(scope.row)">{{$t('execute')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div class="pageDiv">
      <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10,20,50,100]"
         :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
      </el-pagination>
    </div>

    <Modal v-model="modelAdd" id="modelId" :closable='true' :mask-closable='false' :title="$t('addUserInfo')">
      <div slot="footer">
        <Button type="primary" size="small" @click="close">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="addInfo">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="modelForm" label-width="100px">
        <el-row>
          <el-col :xs="24" :md="24">
            <el-form-item :label="$t('jobValue1')" >
              <el-input v-if="updateFlag==0" v-model="modelForm.jobValue" :placeholder="$t('enter')"/>
              <el-input v-if="updateFlag==1" v-model="modelForm.jobValue" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :md="24">
            <el-form-item :label="$t('jobDesc1')" >
              <el-input v-model="modelForm.jobDesc" :placeholder="$t('enter')"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :md="24">
            <el-form-item :label="$t('isvalid1')">
              <el-select v-model="modelForm.isvalid" clearable>
                <el-option v-for="item in RunList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :md="24">
            <el-form-item :label="$t('cycelTime1')">
              <el-input v-model="modelForm.cycelTime" :placeholder="$t('enter')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :md="24">
            <el-form-item :label="$t('jobTime1')">
              <el-input v-model="modelForm.jobTime" :placeholder="$t('enter')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </Modal>
  </div>
</template>
<script>
    import * as validate from '@/utils/validate'

    export default {
        name: 'cronJob',
        created () {
           this.getListenerJobInfo();
        },
        data () {
            return {
              jobValue: null,
              jobDesc:null,
              tableData: [],
              modelForm:{
                jobValue:null,
                jobDesc:null,
                isvalid:null,
                cycelTime:null,
                jobTime:null,
              },
              RunList:[
                { value: '0',label: 'Run'},
                { value: '1',label: 'Stop'},
              ],
              jobId:null,
              updateFlag:0,
              modelAdd:false,
              currentPage: 1,
              totalCount: 0,
              pageSize: 10,
            }
        },
        methods: {
            getListenerJobInfo(){
              let url = `${this.$store.state.islhurl}getListenerJobInfo/${this.pageSize}/${this.currentPage}`
              let pm = {
                jobValue: this.jobValue==''?null:this.jobValue,
                jobDesc: this.jobDesc==''?null:this.jobDesc,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
              this._post(url,pm).then(
                res =>{
                  this.tableData =res.data;
                  this.totalCount = res.totalNums;
                }
              )
            },
            searchJobInfo(){
              this.pageSize = 10;
              this.currentPage = 1;
              let url = `${this.$store.state.islhurl}getListenerJobInfo/${this.pageSize}/${this.currentPage}`
              let pm = {
                jobValue: this.jobValue==''?null:this.jobValue,
                jobDesc: this.jobDesc==''?null:this.jobDesc,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
              this._post(url,pm).then(
                res =>{
                  this.tableData =res.data;
                  this.totalCount = res.totalNums;
                }
              )
            },
            addModel() {
              this.updateFlag = 0;
              this.jobId = null,
              this.modelForm.jobValue = null;
              this.modelForm.jobDesc = null;
              this.modelForm.isvalid = null;
              this.modelForm.cycelTime = null;
              this.modelForm.jobTime = null;
              this.modelAdd = true;
            },
            addInfo(){
              let params ={
                id : this.jobId,
                jobValue : this.modelForm.jobValue,
                jobDesc : this.modelForm.jobDesc,
                isvalid : this.modelForm.isvalid,
                cycelTime : this.modelForm.cycelTime,
                jobTime : this.modelForm.jobTime,
                islhToken : sessionStorage.getItem('islhtoken'),
              };
              let url = `${this.$store.state.islhurl}listenerJobTime/addInfo`
              if(this.jobId != null){
                url = `${this.$store.state.islhurl}listenerJobTime/editInfo`
              }
              this._post(url,params).then(
                res => {
                  if(res == '200'){
                    this.searchJobInfo();
                    this.modelAdd = false;
                    this.$Message.success('Operation Successful');
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
            },
            handleEdit(index) {
              this.updateFlag = 1;
              this.jobId = index.id;
              this.modelForm.jobValue = index.jobValue;
              this.modelForm.jobDesc = index.jobDesc;
              this.modelForm.isvalid = index.isvalid+"";
              this.modelForm.cycelTime = index.cycelTime;
              this.modelForm.jobTime = index.jobTime;
              this.modelAdd = true;
            },
            handleRun(index){
              this.$confirm("Are you sure to execute the job", "Warning", {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
              }).then(() => {
                let params = {
                  jobValue:index.jobValue,
                  islhToken : sessionStorage.getItem('islhtoken'),
                }
                let url = `${this.$store.state.islhurl}listenerJobTime/executeJob`
                this._post(url,params).then(
                  res =>{
                    if(res=="200"){
                      this.$Message.success('Execute Successful' )
                    }else{
                      this.$message({
                        type:'error',
                        showClose:true,
                        duration:10000,
                        message:res
                      });
                    }
                  }
                )
              }).catch(() => {
              });
            },
            close(){
              this.modelAdd = false;
            },
            // 分页
            changePage (val) {
              this.currentPage = val
              this.getListenerJobInfo()
            },
            // 改变当前页显示条数
            changePageSize (val) {
              this.pageSize = val
              this.getListenerJobInfo()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/base/listenerJob.vue